var React = require('react');

function UserInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.50009 5.14783C5.50009 6.539 6.61938 7.66667 8.00009 7.66667C9.3808 7.66667 10.5001 6.539 10.5001 5.14783V4.51883C10.5001 3.12767 9.3808 2 8.00009 2C6.61938 2 5.50009 3.12767 5.50009 4.51883V5.14783ZM2.66675 11.6667C2.66675 9.89333 6.22008 9 8.00008 9C9.78008 9 13.3334 9.89333 13.3334 11.6667V13C13.3334 13.7364 12.7365 14.3333 12.0001 14.3333H4.00008C3.2637 14.3333 2.66675 13.7364 2.66675 13V11.6667Z","fill":"#21A038"}));
}

UserInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = UserInline;

UserInline.default = UserInline;
